import ErrorPage from '../pages/ErrorPage';

const InternalErrorRoute = () => <ErrorPage />;

export default InternalErrorRoute;
